import { createTheme } from '@mui/material/styles';
import componentStyleOverrides from './compStyleOverride';
import themePalette from './palette';
import themeTypography from './typography';
import defaultThemes from './colors';
export const theme = (customization) => {
    const selectedTheme = customization.customTheme || defaultThemes[customization.themeName] || defaultThemes.orange;
    const color = {
        ...selectedTheme,
        grey50: '#fafafa',
        grey100: '#f5f5f5',
        grey200: '#eeeeee',
        grey500: '#9e9e9e',
        grey700: '#616161',
        grey900: '#212121',
        darkPaper: '#111936',
        darkTextPrimary: '#212121',
        darkTextSecondary: '#616161',
        darkLevel1: '#29314f',
        darkLevel2: '#212946',
        darkBackground: '#1d253b',
        paper: '#ffffff',
        errorLight: '#ef9a9a',
        errorMain: '#f44336',
        errorDark: '#c62828',
        warningLight: '#ffe57f',
        warningMain: '#ffc107',
        warningDark: '#ff8f00',
        successLight: '#b9f6ca',
        success200: '#69f0ae',
        successMain: '#00e676',
        successDark: '#00c853',
        orangeLight: '#fbe9e7',
        orangeMain: '#ffab91',
        orangeDark: '#d84315'
    };
    const themeOption = {
        colors: color,
        heading: color.grey900,
        paper: color.paper,
        backgroundDefault: color.paper,
        background: color.primaryLight,
        darkTextPrimary: color.grey700,
        darkTextSecondary: color.grey500,
        textDark: color.grey900,
        menuSelected: color.secondaryDark,
        menuSelectedBack: color.secondaryLight,
        divider: color.grey200,
        customization
    };
    const themeOptions = { direction: 'ltr', palette: themePalette(themeOption), typography: themeTypography(themeOption) };
    const themes = createTheme(themeOptions);
    themes.components = componentStyleOverrides(themeOption);
    return themes;
};
export default theme;
